import { Box } from '@hub/box';
import React from 'react';
import UtilityPanel from '../../utility-panel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const HeaderQuickLinks = _ref => {
  let {
    items
  } = _ref;
  if (!Array.isArray(items)) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Box, {
      marginTop: ['spacing-md', null, 'spacing-lg'],
      marginBottom: ['spacing-md', null, 'spacing-lg'],
      "data-id": "header-quick-links_index_HeaderQuickLinks_Box",
      children: /*#__PURE__*/_jsx(UtilityPanel, {
        items: items.map(_ref2 => {
          let {
            label,
            url,
            image
          } = _ref2;
          return {
            // to accommodate legacy props in UtilityPanel
            __typename: 'SGPageTemplateContentEntry',
            kind: 'featuredLink',
            title: label,
            image: {
              type: 'SQUARE',
              url: image,
              alt: null
            },
            callToAction: {
              url,
              label
            },
            viewItem: () => {}
          };
        }),
        "data-id": "header-quick-links_index_HeaderQuickLinks_Box_UtilityPanel"
      })
    })
  });
};